<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="planes">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="pink darken-4">
                        <v-toolbar-title>Planes de Estudio&nbsp;&nbsp;</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-btn
                                :disabled="(bEditPlan || bEditCourse)"
                                text
                                class="text-none"
                                @click="onNewPlan"
                            >Nuevo Plan</v-btn>
                            <v-btn
                                :disabled="(bEditPlan || bEditCourse || planID === 0)"
                                text
                                class="text-none"
                                @click="onEditPlan"
                            >Editar Plan</v-btn>
                            <v-btn
                                :disabled="(bEditPlan || bEditCourse || planID === 0 )"
                                text
                                class="text-none"
                                @click="onDeletePlan"
                            >Borrar Plan</v-btn>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text :disabled="(bEditPlan || bEditCourse)" @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-list-item :disabled="(bEditPlan || bEditCourse)" @click="onNewPlan">
                                    <v-list-item-title>
                                        <v-icon color="brown darken-1">mdi-map-plus</v-icon>&nbsp; Nuevo Plan
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="(bEditPlan || bEditCourse || planID === 0)" @click="onEditPlan">
                                    <v-list-item-title>
                                        <v-icon color="brown darken-1">mdi-pencil</v-icon>&nbsp; Editar Plan
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="(bEditPlan || bEditCourse || planID === 0)" @click="onDeletePlan">
                                    <v-list-item-title>
                                        <v-icon color="brown darken-1">mdi-map-minus</v-icon>&nbsp; Borrar Plan
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item :disabled="(bEditPlan || bEditCourse)" @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red">mdi-close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de planes y plan seleccionado: -->
                    <v-container fluid grid-list-md class="mx-auto">
                        <!-- Renglón único para lista de planes y card de plan seleccionado: -->
                        <v-layout row wrap justify-space-around>
                            <!-- Lista de Planes: *************************** -->
                            <v-flex xs11 md2>
                                <v-card>
                                    <v-toolbar dense color="pink darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title">Planes</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-format-list-bulleted</v-icon>
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        :height="planListHeight"
                                        max-height="100%"
                                        class="overflow-y-auto"
                                        color="grey lighten-4"
                                        :disabled="(loadingData || bEditPlan || bEditCourse)"
                                    >
                                        <v-list-item-group
                                            v-model="selectedPlanIndex"
                                            color="orange accent-4"
                                            :mandatory="!bNewPlan"
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(plan, i) in planesEstudios"
                                                :key="i"
                                                @click="selectPlan(plan.planid)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex
                                                                    md2
                                                                    xs6
                                                                >{{ plan.plan }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Termina Lista de Planes ********************************* -->

                            <!-- Info de plan seleccionado: *********************** -->
                            <v-flex xs11 md10>
                                <v-card class="grey lighten-3" ref="plan_card">

                                    <v-toolbar :height="planToolbarHeight" color="red lighten-2" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >{{ selectedPlanName }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-map-outline</v-icon>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container fluid>
                                            <v-layout wrap>
                                                <v-flex xs12 md5>
                                                     <v-text-field
                                                        dense
                                                        name="nombrePlan"
                                                        label="Nombre del plan"
                                                        type="text"
                                                        v-model="nombrePlan"
                                                        :readonly="!bEditPlan"
                                                        color="pink darken-4"
                                                        ref="plan_name_field"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs6 md2>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-calendar-month"
                                                        label="Año de inicio"
                                                        type="number"
                                                        v-model="anioInicio"
                                                        :readonly="!bEditPlan"
                                                        color="pink darken-4"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs6 md2>
                                                    <v-select
                                                        dense
                                                        :items="seasons"
                                                        item-text="term"
                                                        item-value="termID"
                                                        v-model="periodoInicioID"
                                                        :readonly="!bEditPlan"
                                                        label="Periodo"
                                                        color="red darken-4"
                                                        item-color="red darken-4"
                                                        reverse
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs10>
                                                    <div class="text-xs-left">
                                                        <span
                                                            class="pink--text text--darken-3 body-1"
                                                        >
                                                            <v-icon
                                                                color="pink darken-3"
                                                                >mdi-counter</v-icon
                                                            >&nbsp;Créditos
                                                        </span>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout wrap justify-space-between>
                                                <v-flex xs6 sm4 md2>
                                                     <v-text-field
                                                        dense
                                                        label="Materias obligatorias"
                                                        type="number"
                                                        v-model="creditosObligatorias"
                                                        :readonly="!bEditPlan"
                                                        color="pink darken-4"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs6 sm4 md2>
                                                     <v-text-field
                                                        dense
                                                        label="Materias optativas"
                                                        type="number"
                                                        v-model="creditosOptativas"
                                                        :readonly="!bEditPlan"
                                                        color="pink darken-4"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs6 sm4 md2>
                                                     <v-text-field
                                                        dense
                                                        label="Créditos totales"
                                                        type="number"
                                                        v-model="totalCreditos"
                                                        readonly
                                                        color="pink darken-4"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs6 sm4 md2>
                                                     <v-text-field
                                                        dense
                                                        label="Número de optativas"
                                                        type="number"
                                                        v-model="numOptativas"
                                                        :readonly="!bEditPlan"
                                                        color="pink darken-4"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row>
                                                <v-flex xs10>
                                                    <div class="text-xs-left">
                                                        <span
                                                            class="pink--text text--darken-3 body-1"
                                                        >
                                                            <v-icon
                                                                color="pink darken-3"
                                                                >mdi-view-dashboard</v-icon
                                                            >&nbsp;Secuencias Formativas
                                                        </span>
                                                    </div>
                                                </v-flex>
                                                <v-flex xs2 class="text-right">
                                                    <v-toolbar
                                                        height="30"
                                                        color="grey lighten-3"
                                                        flat
                                                    >
                                                        <v-spacer></v-spacer>
                                                        <v-menu offset-y>
                                                            <template v-slot:activator="{
                                                                on,}"
                                                            >
                                                                <v-btn icon v-on="on" :disabled="!bEditPlan">
                                                                    <v-icon color="pink darken-3">mdi-dots-vertical</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <v-list color="pink lighten-5">
                                                                <v-list-item @click="onNewSeq">
                                                                    <v-list-item-title>
                                                                        <v-icon color="pink darken-3">mdi-view-grid-plus</v-icon>
                                                                            &nbsp;Nueva Secuencia
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                            <v-list color="pink lighten-5">
                                                                <v-list-item @click="onEditSeq">
                                                                    <v-list-item-title>
                                                                        <v-icon color="pink darken-3">mdi-view-dashboard-edit</v-icon>
                                                                            &nbsp;Editar Secuencia
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                            <v-list color="pink lighten-5">
                                                                <v-list-item @click="onDeleteSeq">
                                                                    <v-list-item-title>
                                                                        <v-icon color="pink darken-3">mdi-delete</v-icon>
                                                                            &nbsp;Borrar Secuencia
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-menu>
                                                    </v-toolbar>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout wrap justify-space-around>
                                                <v-flex xs11 md5>
                                                    <v-card>
                                                        <v-toolbar height="30" color="pink darken-3" dark flat>
                                                            <v-toolbar-title class="my-list-subtitle">Secuencias</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-icon>mdi-view-dashboard</v-icon>
                                                        </v-toolbar>

                                                        <v-list
                                                            subheader
                                                            dense
                                                            :height="seqListHeight"
                                                            max-height="100%"
                                                            class="overflow-y-auto"
                                                            color="grey lighten-4"
                                                            :disabled="loadingData"
                                                        >
                                                            <!-- :mandatory="!bNewPlan" -->
                                                            <v-list-item-group
                                                                v-model="selectedSequenceIndex"
                                                                color="orange accent-4"
                                                                mandatory
                                                            >
                                                                <v-list-item
                                                                    class="my-list-item"
                                                                    v-for="(seq, i) in secuenciasFormativas"
                                                                    :key="i"
                                                                    @click="selectSequence(seq.secuenciaid)"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <v-container pa-0 fluid>
                                                                                <v-layout row wrap>
                                                                                    <v-flex
                                                                                        md2
                                                                                        xs6
                                                                                    >{{ seq.secuencia }} - {{ seq.materiasObligatorias }} materias obligatorias, {{ seq.materiasOptativas }} optativas</v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-flex>
                                                <v-flex xs11 md6>
                                                    <v-card>
                                                        <v-toolbar height="30" color="pink darken-3" dark flat>
                                                            <v-toolbar-title class="my-list-subtitle">{{ opcionesListTitle }}</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <!-- <v-icon>mdi-arrow-decision</v-icon> -->
                                                            <v-menu offset-y :disabled="secuenciasFormativas.length < 1">
                                                                <template v-slot:activator="{
                                                                    on,}"
                                                                >
                                                                    <v-btn icon v-on="on" :disabled="!bEditPlan">
                                                                        <v-icon>mdi-dots-vertical</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <v-list color="pink lighten-5">
                                                                    <v-list-item @click="onNewOption">
                                                                        <v-list-item-title>
                                                                            <v-icon color="pink darken-3">mdi-plus</v-icon>
                                                                                &nbsp;Nueva Opción
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                </v-list>
                                                                <v-list color="pink lighten-5">
                                                                    <v-list-item @click="onEditOption">
                                                                        <v-list-item-title>
                                                                            <v-icon color="pink darken-3">mdi-pencil</v-icon>
                                                                                &nbsp;Editar Opción
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                </v-list>
                                                                <v-list color="pink lighten-5">
                                                                    <v-list-item @click="onDeleteOption">
                                                                        <v-list-item-title>
                                                                            <v-icon color="pink darken-3">mdi-delete</v-icon>
                                                                                &nbsp;Borrar Opción
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                </v-list>
                                                            </v-menu>
                                                        </v-toolbar>

                                                        <v-list
                                                            subheader
                                                            dense
                                                            :height="seqListHeight"
                                                            max-height="100%"
                                                            class="overflow-y-auto"
                                                            color="grey lighten-4"
                                                            :disabled="loadingData"
                                                        >
                                                        <!-- :mandatory="!bNewPlan" -->
                                                            <v-list-item-group
                                                                v-model="selectedOptionIndex"
                                                                color="orange accent-4"
                                                                mandatory
                                                            >
                                                                <v-list-item
                                                                    class="my-list-item"
                                                                    v-for="(opt, i) in opcionesSecuencia"
                                                                    :key="i"
                                                                    @click="selectOption(opt.opcionid)"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <v-container pa-0 fluid>
                                                                                <v-layout row wrap>
                                                                                    <v-flex
                                                                                        md2
                                                                                        xs6
                                                                                    >{{ opt.opcion }}</v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout
                                                v-if="bEditPlan"
                                                align-center
                                                justify-end
                                                row
                                                fill-height
                                            >
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSavePlan"
                                                        :disabled="!bEditPlan"
                                                    >Guardar Plan de Estudios</v-btn>
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancelEditPlan"
                                                        :disabled="!bEditPlan"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>

                                            <br />

                                            <v-divider
                                                class="pink darken-1"
                                            ></v-divider>
                                            
                                            <br />
                                            
                                            <v-layout row>
                                                <v-flex xs6>
                                                    <div class="text-xs-left">
                                                        <span
                                                            class="pink--text text--darken-3 body-1"
                                                        >
                                                            <v-icon
                                                                color="pink darken-3"
                                                                >mdi-book-outline</v-icon
                                                            >&nbsp;Materias
                                                        </span>
                                                    </div>
                                                </v-flex>
                                                <v-flex xs6 class="text-right">
                                                    <v-toolbar
                                                        height="30"
                                                        color="grey lighten-3"
                                                        flat
                                                    >
                                                        <v-spacer></v-spacer>
                                                        <v-menu offset-y>
                                                            <template v-slot:activator="{
                                                                on,}"
                                                            >
                                                                <v-btn icon v-on="on" :disabled="bEditCourse || bEditPlan">
                                                                    <v-icon color="pink darken-3">mdi-dots-vertical</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <v-list color="pink lighten-5">
                                                                <v-list-item @click="onNewCourse">
                                                                    <v-list-item-title>
                                                                        <v-icon color="pink darken-3">mdi-book-plus</v-icon>
                                                                            &nbsp;Nueva Materia
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                            <v-list color="pink lighten-5">
                                                                <v-list-item @click="onEditCourse">
                                                                    <v-list-item-title>
                                                                        <v-icon color="pink darken-3">mdi-book-edit</v-icon>
                                                                            &nbsp;Editar Materia
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                            <v-list color="pink lighten-5">
                                                                <v-list-item @click="onDeleteCourse">
                                                                    <v-list-item-title>
                                                                        <v-icon color="pink darken-3">mdi-book-minus</v-icon>
                                                                            &nbsp;Borrar Materia
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-menu>
                                                    </v-toolbar>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap justify-space-around>
                                                <v-flex xs12 md4>
                                                    <v-card>
                                                        <v-toolbar :height="courseToolbarHeight" color="pink darken-3" dark flat>
                                                            <v-toolbar-title class="my-list-subtitle">Materias</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-text-field
                                                                hide-details
                                                                single-line
                                                                v-model="searchText"
                                                                dense
                                                                :disabled="bEditPlan || bEditCourse"
                                                            ></v-text-field>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn :disabled="bEditPlan || bEditCourse" small icon @click="onSearchCourse" v-on="on">
                                                                        <v-icon>mdi-magnify</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Buscar por nombre, clave o sigla</span>
                                                            </v-tooltip>
                                                        </v-toolbar>

                                                        <v-list
                                                            subheader
                                                            dense
                                                            :height="courseListHeight"
                                                            max-height="100%"
                                                            class="overflow-y-auto"
                                                            color="grey lighten-4"
                                                            :disabled="(loadingData || bEditPlan || bEditCourse)"
                                                        >
                                                            <v-list-item-group
                                                                v-model="selectedCourseIndex"
                                                                color="orange accent-4"
                                                                :mandatory="!bNewCourse"
                                                            >
                                                                <v-list-item
                                                                    class="my-list-item"
                                                                    v-for="(materia, i) in materiasPlan"
                                                                    :key="i"
                                                                    @click="selectCourse(materia.materiaid)"
                                                                    :id="materia.materiaid"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <v-container pa-0 fluid>
                                                                                <v-layout row wrap>
                                                                                    <v-flex
                                                                                        md2
                                                                                        xs6
                                                                                    >{{ materia.materia }}</v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-flex>
                                                <v-flex xs12 md8>
                                                    <v-card ref="course_card">
                                                        
                                                        <v-toolbar :height="courseToolbarHeight" color="pink darken-3" dark flat>
                                                            <v-toolbar-title class="my-list-subtitle">{{ selectedCourseName }}</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-icon>mdi-clipboard-text</v-icon>
                                                        </v-toolbar>

                                                        <v-card-text>
                                                            <v-container fluid>
                                                                <v-layout wrap>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            dense
                                                                            name="nombreMateria"
                                                                            label="Nombre de la materia"
                                                                            type="text"
                                                                            v-model="nombreMateria"
                                                                            :readonly="!bEditCourse"
                                                                            color="pink darken-4"
                                                                            ref="materia_name_field"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row justify-space-between>
                                                                    <v-flex xs6 sm3 md2>
                                                                        <v-text-field
                                                                            dense
                                                                            label="Clave"
                                                                            type="text"
                                                                            v-model="clave"
                                                                            :readonly="!bEditCourse"
                                                                            color="pink darken-4"
                                                                            reverse
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                    <v-flex xs6 sm3 md2>
                                                                        <v-text-field
                                                                            dense
                                                                            label="Sigla"
                                                                            type="text"
                                                                            v-model="sigla"
                                                                            :readonly="!bEditCourse"
                                                                            color="pink darken-4"
                                                                            reverse
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                    <v-flex xs4 md2>
                                                                        <v-text-field
                                                                            dense
                                                                            label="Créditos"
                                                                            type="number"
                                                                            v-model="creditosMateria"
                                                                            :readonly="!bEditCourse"
                                                                            color="pink darken-4"
                                                                            reverse
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                    <v-flex xs4 md2>
                                                                        <v-text-field
                                                                            dense
                                                                            label="Horas"
                                                                            type="number"
                                                                            v-model="horas"
                                                                            :readonly="!bEditCourse"
                                                                            color="pink darken-4"
                                                                            reverse
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                    <v-flex xs4 sm5 md2>
                                                                        <v-text-field
                                                                            dense
                                                                            label="Semestre ideal"
                                                                            type="number"
                                                                            v-model="semestreIdeal"
                                                                            :readonly="!bEditCourse"
                                                                            color="pink darken-4"
                                                                            reverse
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row justify-space-between>
                                                                    <v-flex xs12 sm6 md3>
                                                                        <v-checkbox
                                                                            :dense="bDense"
                                                                            :readonly="!bEditCourse"
                                                                            label="Obligatoria"
                                                                            v-model="obligatoria"
                                                                            color="orange accent-4"
                                                                        ></v-checkbox>
                                                                    </v-flex>
                                                                    <v-flex xs12 sm6 md3>
                                                                        <v-checkbox
                                                                            :dense="bDense"
                                                                            :readonly="!bEditCourse"
                                                                            label="Verano"
                                                                            v-model="verano"
                                                                            color="orange accent-4"
                                                                        ></v-checkbox>
                                                                    </v-flex>
                                                                    <v-flex xs12 md6>
                                                                        <v-select
                                                                            :dense="bDense"
                                                                            :items="areas"
                                                                            item-text="area"
                                                                            item-value="areaid"
                                                                            v-model="areaID"
                                                                            label="Área"
                                                                            color="pink darken-3"
                                                                            item-color="pink darken-3"
                                                                            :readonly="!bEditCourse"
                                                                            :background-color="colorArea"
                                                                            @change="onSelectAreaMateria"
                                                                            outlined
                                                                        ></v-select>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row justify-space-between>
                                                                    <v-flex xs12 md6>
                                                                        <v-select
                                                                            :dense="bDense"
                                                                            :items="secuenciasFormativas"
                                                                            item-text="secuencia"
                                                                            item-value="secuenciaid"
                                                                            v-model="materiaSecuenciaID"
                                                                            label="Secuencia formativa"
                                                                            color="pink darken-3"
                                                                            item-color="pink darken-3"
                                                                            :readonly="!bEditCourse"
                                                                            @change="onSelectSecuenciaMateria"
                                                                            :clearable = bEditCourse
                                                                        ></v-select>
                                                                    </v-flex>
                                                                    <v-flex xs12 md6>
                                                                        <v-select
                                                                            :dense="bDense"
                                                                            :items="materiaOpcionesSecuencia"
                                                                            item-text="opcion"
                                                                            item-value="opcionid"
                                                                            v-model="materiaOpcionID"
                                                                            label="Opción"
                                                                            color="pink darken-3"
                                                                            item-color="pink darken-3"
                                                                            :readonly="!bEditCourse"
                                                                            no-data-text="Seleccione una secuencia formativa"
                                                                        ></v-select>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-textarea
                                                                            dense
                                                                            outlined
                                                                            v-model="descripcion"
                                                                            :auto-grow="false"
                                                                            no-resize
                                                                            color="pink darken-3"
                                                                            label="Descripción"
                                                                            rows="3"
                                                                            :readonly="!bEditCourse"
                                                                            counter="255"
                                                                        ></v-textarea>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-card>
                                                                            <v-toolbar height="20" color="purple darken-2" dark flat>
                                                                                <v-toolbar-title class="my-list-subtitle">Prerrequisitos</v-toolbar-title>
                                                                                <v-spacer></v-spacer>
                                                                                <!-- <v-icon>mdi-multicast</v-icon> -->
                                                                                <v-menu offset-y>
                                                                                    <template v-slot:activator="{
                                                                                        on,}"
                                                                                    >
                                                                                        <v-btn x-small icon v-on="on" :disabled="!bEditCourse">
                                                                                            <v-icon>mdi-dots-vertical</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <v-list color="pink lighten-5">
                                                                                        <v-list-item @click="onAddPrereq">
                                                                                            <v-list-item-title>
                                                                                                <v-icon color="purple darken-2">mdi-plus</v-icon>
                                                                                                    &nbsp;Agregar Prerrequisito
                                                                                            </v-list-item-title>
                                                                                        </v-list-item>
                                                                                        <v-list-item @click="onDeletePrereq" :disabled="prerreqID === 0">
                                                                                            <v-list-item-title>
                                                                                                <v-icon color="purple darken-2" :disabled="prerreqID === 0">mdi-delete</v-icon>
                                                                                                    &nbsp;Borrar Prerrequisito
                                                                                            </v-list-item-title>
                                                                                        </v-list-item>
                                                                                    </v-list>
                                                                                </v-menu>
                                                                            </v-toolbar>

                                                                            <v-list
                                                                                subheader
                                                                                dense
                                                                                :height="prerreqListHeight"
                                                                                max-height="100%"
                                                                                class="overflow-y-auto"
                                                                                color="grey lighten-3"
                                                                                :disabled="loadingData"
                                                                            >
                                                                                <v-list-item-group
                                                                                    v-model="selectedPrerreqIndex"
                                                                                    color="pink darden-4"
                                                                                    :mandatory="!bNewPlan"
                                                                                >
                                                                                    <v-list-item
                                                                                        class="my-list-item"
                                                                                        v-for="(prerreq, i) in prerrequisitos"
                                                                                        :key="i"
                                                                                        @click="selectPrereq(prerreq.materiaid)"
                                                                                    >
                                                                                        <v-list-item-content>
                                                                                            <v-list-item-title>
                                                                                                <v-container pa-0 fluid>
                                                                                                    <v-layout row wrap>
                                                                                                        <v-flex
                                                                                                            md2
                                                                                                            xs6
                                                                                                        >{{ prerreq.clave }} - {{ prerreq.materia }}</v-flex>
                                                                                                    </v-layout>
                                                                                                </v-container>
                                                                                            </v-list-item-title>
                                                                                        </v-list-item-content>
                                                                                    </v-list-item>
                                                                                </v-list-item-group>
                                                                            </v-list>
                                                                        </v-card>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-card-text>
                                                        
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout
                                                v-if="bEditCourse"
                                                align-center
                                                justify-end
                                                row
                                                fill-height
                                            >
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSaveCourse"
                                                        :disabled="!bEditCourse"
                                                    >Guardar Materia</v-btn>
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancelEditCourse"
                                                        :disabled="!bEditCourse"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info de materia seleccionada *********************** -->
                        </v-layout>

                        <!-- Modal para editar o agregar una nueva secuencia formativa: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDlgEditSeq"
                                persistent
                                max-width="35%"
                            >
                                <v-card class="grey lighten-2">
                                    <v-toolbar dense color="pink darken-4" dark flat>
                                        <v-toolbar-title v-if="bNewSeq" class="my-list-title"><v-icon>mdi-view-dashboard</v-icon> &nbsp; Agregar secuencia formativa &nbsp;</v-toolbar-title>
                                        <v-toolbar-title v-else class="my-list-title"><v-icon>mdi-view-dashboard</v-icon> &nbsp; Editar secuencia formativa &nbsp;</v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container grid-list-sm fluid>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        label="Nombre de la secuencia"
                                                        type="text"
                                                        v-model="seqToEdit"
                                                        color="pink darken-4"
                                                    ></v-text-field>
                                                </v-flex>                           
                                            </v-layout>
                                            <v-layout row justify-space-between>
                                                <v-flex xs12 sm5>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        label="Materias obligatorias"
                                                        type="number"
                                                        v-model="mandatoryCourses"
                                                        color="pink darken-4"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm5>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        label="Materias optativas"
                                                        type="number"
                                                        v-model="optionalCourses"
                                                        color="pink darken-4"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <v-textarea
                                                        :dense="bDense"
                                                        outlined
                                                        v-model="sequenceLabel"
                                                        :auto-grow="false"
                                                        no-resize
                                                        color="pink darken-4"
                                                        label="Leyenda para los alumnos"
                                                        rows="3"
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmSeqEdition"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelSeqEdition"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para agregar o editar una secuencia formativa ************************ -->

                        <!-- Modal para confirmar borrado de secuencia formativa: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingSeq" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Secuencia Formativa</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar la secuencia "{{ selectedSeqName }}"?
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteSeqConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteSeq"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de secuencia formativa *************************** -->

                        <!-- Modal para editar o agregar una nueva opción: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDlgEditOption"
                                persistent
                                max-width="35%"
                            >
                                <v-card class="grey lighten-2">
                                    <v-toolbar dense color="pink darken-4" dark flat>
                                        <v-toolbar-title v-if="bNewOption" class="my-list-title"><v-icon>mdi-view-dashboard</v-icon> &nbsp; Agregar opción &nbsp;</v-toolbar-title>
                                        <v-toolbar-title v-else class="my-list-title"><v-icon>mdi-view-dashboard</v-icon> &nbsp; Editar opción &nbsp;</v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container grid-list-sm fluid>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        label="Nombre de la opción"
                                                        type="text"
                                                        v-model="optionToEdit"
                                                        color="pink darken-4"
                                                    ></v-text-field>
                                                </v-flex>                           
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmOptionEdition"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelOptionEdition"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para agregar o editar una opción ************************ -->

                        <!-- Modal para confirmar borrado de opción: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingOption" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Opción</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar la opción "{{ selectedOptName }}"?
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteOptionConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteOption"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de opción *************************** -->

                        <!-- Modal para confirmar borrado de plan: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingPlan" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Plan</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar el plan {{ selectedPlanName }}?
                                    </v-card-title>
                                    <v-card-text
                                        class="text-center"
                                    >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deletePlanConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeletePlan"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de plan *************************** -->

                        <!-- Modal para confirmar borrado de prerrequisito: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingPrereq" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Prerrequisito</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea quitar "{{ selectedPrereqName }}" como prerrequisito para esta materia?
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="confirmDeletePrereq"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeletePrereq"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de prerrequisito *************************** -->

                        <!-- Modal para confirmar borrado de materia: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingCourse" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Materia</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar al plan {{ selectedCourseName }}?
                                    </v-card-title>
                                    <v-card-text
                                        class="text-center"
                                    >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteCourseConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteCourse"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de materia *************************** -->

                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Búsqueda de Materias</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >No se encontró ninguna materia con ese parámetro.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para informar que no hubo resultados en la búsqueda *************************** -->

                        
                        <!-- Modal para pedir que se introduzcan todos los campos obligatorios: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="pink darken-4" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Información Incompleta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                >{{ errorMessage }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introuzcan todos los campos *********************************** -->

                        <!-- Modal para agregar un prerrequisito: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDlgAddPrereq"
                                persistent
                                max-width="80%"
                            >
                                <v-card class="grey lighten-2">
                                    <v-toolbar dense color="pink darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title"><v-icon>mdi-bookmark-check</v-icon> &nbsp; Agregar prerrequisito &nbsp;</v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container grid-list-sm fluid>
                                            <v-layout row wrap justify-space-around>
                                                <!-- Lista de materias: *************************** -->
                                                <v-flex xs10 sm5>
                                                    <v-card>
                                                        <v-toolbar height="40" dense color="pink darken-2" dark flat>
                                                            <v-toolbar-title class="my-list-title">Materias &nbsp;</v-toolbar-title>
                                                            <v-text-field
                                                                hide-details
                                                                single-line
                                                                v-model="searchText"
                                                                dense
                                                            ></v-text-field>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn small icon @click="onSearchNoPrerreq" v-on="on">
                                                                        <v-icon>mdi-magnify</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Buscar por nombre, clave o sigla</span>
                                                            </v-tooltip>
                                                            <v-spacer></v-spacer>
                                                            <v-icon>mdi-format-list-bulleted</v-icon>
                                                        </v-toolbar>

                                                        <v-list
                                                            subheader
                                                            dense
                                                            :height="noPrerreqlistHeight"
                                                            max-height="100%"
                                                            class="overflow-y-auto"
                                                            color="grey lighten-4"
                                                            :disabled="loadingData"
                                                        >
                                                            <v-list-item-group
                                                                v-model="selectedNoPrerreqIndex"
                                                                color="orange accent-4"
                                                                mandatory
                                                            >
                                                                <v-list-item
                                                                    class="my-list-item"
                                                                    v-for="(course, i) in noPrerrequisitos"
                                                                    :key="i"
                                                                    @click="selectNoPrerreq(course.materiaid)"
                                                                    :id="-course.materiaid"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <v-container pa-0 fluid>
                                                                                <v-layout row wrap>
                                                                                    <v-flex
                                                                                        md2
                                                                                        xs6
                                                                                    >{{  course.clave + " - " + course.materia }}</v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-flex>
                                                <!-- Termna lista de materias ***************************************** -->
                                                <!-- Info de materia seleccionada ************************************* -->
                                                <v-flex xs10 sm7>
                                                    <v-card class="grey lighten-4">
                                                        <v-toolbar height="40" color="red lighten-2" flat>
                                                            <v-toolbar-title class="my-list-title">{{ selectedNoPrereqName }}</v-toolbar-title>
                                                        </v-toolbar>

                                                        <v-card-text>
                                                            <v-container fluid>
                                                                <v-layout wrap justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            dense
                                                                            name="nombreMateria"
                                                                            label="Nombre de la materia"
                                                                            type="text"
                                                                            v-model="nombrePrerreq"
                                                                            readonly
                                                                            color="pink darken-4"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row justify-space-between>
                                                                    <v-flex xs6 sm3 md2>
                                                                        <v-text-field
                                                                            dense
                                                                            label="Clave"
                                                                            type="text"
                                                                            v-model="clavePrerreq"
                                                                            readonly
                                                                            color="pink darken-4"
                                                                            reverse
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                    <v-flex xs6 sm3 md2>
                                                                        <v-text-field
                                                                            dense
                                                                            label="Sigla"
                                                                            type="text"
                                                                            v-model="siglaPrerreq"
                                                                            readonly
                                                                            color="pink darken-4"
                                                                            reverse
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                    <v-flex xs4 md2>
                                                                        <v-text-field
                                                                            dense
                                                                            label="Créditos"
                                                                            type="number"
                                                                            v-model="creditosPrerreq"
                                                                            readonly
                                                                            color="pink darken-4"
                                                                            reverse
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                    <v-flex xs4 md2>
                                                                        <v-text-field
                                                                            dense
                                                                            label="Horas"
                                                                            type="number"
                                                                            v-model="horasPrerreq"
                                                                            readonly
                                                                            color="pink darken-4"
                                                                            reverse
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                    <v-flex xs4 md2>
                                                                        <v-text-field
                                                                            dense
                                                                            label="Semestre ideal"
                                                                            type="number"
                                                                            v-model="semestreIdealPrerreq"
                                                                            readonly
                                                                            color="pink darken-4"
                                                                            reverse
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row justify-space-between>
                                                                    <v-flex xs12 sm6 md3>
                                                                        <v-checkbox
                                                                            :dense="bDense"
                                                                            readonly
                                                                            label="Obligatoria"
                                                                            v-model="obligatoriaPrerreq"
                                                                            color="orange accent-4"
                                                                        ></v-checkbox>
                                                                    </v-flex>
                                                                    <v-flex xs12 sm6 md3>
                                                                        <v-checkbox
                                                                            :dense="bDense"
                                                                            readonly
                                                                            label="Verano"
                                                                            v-model="veranoPrerreq"
                                                                            color="orange accent-4"
                                                                        ></v-checkbox>
                                                                    </v-flex>
                                                                    <v-flex xs12 md6>
                                                                        <v-text-field
                                                                            dense
                                                                            label="Área"
                                                                            v-model="areaPrerreq"
                                                                            readonly
                                                                            color="pink darken-4"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                    <v-flex xs6>
                                                                        <v-text-field
                                                                            dense
                                                                            label="Secuencia formativa"
                                                                            v-model="secuenciaPrerreq"
                                                                            readonly
                                                                            color="pink darken-4"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                    <v-flex xs6>
                                                                        <v-text-field
                                                                            dense
                                                                            label="Opción"
                                                                            v-model="opcionPrerreq"
                                                                            readonly
                                                                            color="pink darken-4"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-card-text>

                                                    </v-card>
                                                </v-flex>
                                                <!-- Termina info de materia seleccionada ***************************** -->
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="confirmAddPrereq"
                                        >Agregar prerrequisito</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelAddPrereq"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para agregar un prerrequisito ************************ -->
                        
                        <!-- Termina renglón único para lista de planes y plan seleccionado -->
                    </v-container>
                    <!-- Termina container para lista de planes y plan seleccionado -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'planes',
    data() {
        return {
            bDense: true,
            drawer: false,
            bMounted: false, //Para saber si ya se puede obtener la altura de los componentes.
            courseToolbarHeight: 40,
            planToolbarHeight: 48,
            
            bEditPlan: false,
            bEditCourse: false,
            bNewPlan: false,
            bNewCourse: false,

            bDlgEditSeq: false,
            bNewSeq: false,
            seqToEdit: '',
            mandatoryCourses: 0,
            optionalCourses: 0,
            sequenceLabel: '',
            bDeletingSeq: false,
            newSeqID: 0, //Para poder seleccionar una nueva secuencia en cuanto se agrega.

            bDlgEditOption: false,
            bNewOption: false,
            optionToEdit: false,
            bDeletingOption: false,
            newOptID: 0, //Para poder seleccionar una nueva opción en cuanto se agrega.
            
            bInvalidData: false,
            errorMessage: '',

            planID: 0,
            secuenciaID: 0,
            selectedSeqName: '',
            opcionID: 0,
            
            selectedOptName: '',
            nombrePlan: '',

            periodoInicioID: 0,
            seasons: [
                {
                    termID: 1,
                    term: 'Primavera'
                },
                {
                    termID: 2,
                    term: 'Verano'
                },
                {
                    termID: 3,
                    term: 'Otoño'
                }
            ],

            anioInicio: 0,
            //creditosPlan: 0,
            creditosObligatorias: 0,
            creditosOptativas: 0,
            numOptativas: 0,
          
            secuenciasFormativas: [],
            opcionesSecuencia: [],
            
            bMenuDateIni: false,
            selectedSequenceIndex: 0,
            selectedOptionIndex: 0,
            selectedPrerreqIndex: 0,
            selectedNoPrerreqIndex: 0,
            
            selectedPlanName: '',
            selectedCourseName: '',
            selectedPrereqName: '',

            nombreMateria: '',
            clave: '',
            sigla: '',
            creditosMateria: 0,
            horas: 0,
            semestreIdeal: 0,

            obligatoria: false,
            verano: false,
            areaID: 0,
            colorArea: '',
            materiaSecuenciaID: 0,
            materiaOpcionesSecuencia: [],//Opciones de la secuencia seleccionada para la materia seleccionada
            
            materiaOpcionID: 0,
            descripcion: '',
            prerrequisitos: [],
            noPrerrequisitos: [], //Lista de materias que no son prerrequisitos de la materia seleccionada, y por lo tanto pueden aparecer en el modal para agregar un prerrequisito.


            bDeletingPlan: false,
            bDeletingCourse: false,
            searchText: '',
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.

            bDlgAddPrereq: false,
            prerreqID: 0,
            noPrerreqID: 0,
            selectedNoPrereqName: '',
            nombrePrerreq: '',
            clavePrerreq: '',
            siglaPrerreq: '',
            creditosPrerreq: 0,
            horasPrerreq: 0,
            semestreIdealPrerreq: 0,
            obligatoriaPrerreq: false,
            veranoPrerreq: false,
            areaPrerreq: '',
            secuenciaPrerreq: '',
            opcionPrerreq: '',
            bDeletingPrereq: false,
            bCourseEdited: false, //Evita que se seleccione automáticamente la primera materia de la lista cuando se edita o cuando se registra una materia.
        };
    },
    created() {
        this.materiasPlanLoaded = false;
        this.selectFirstPlan();
        
    },

    mounted() {
        //console.log("mounted(), this.$refs.course_card.$e1.clientHeight = ", this.$refs.course_card.$el.clientHeight);
        //console.log("mounted(), this.$refs.plan_card.$e1.clientHeight = ", this.$refs.plan_card.$el.clientHeight);
        this.bMounted = true;
    },
    
    
    methods: {
        onClose() {
            this.$router.push('/');
        },

        selectFirstSecuence()
        {
            if (this.secuenciasFormativas.length > 0)
            {
                this.selectedSequenceIndex = 0;
                var seqID = this.secuenciasFormativas[this.selectedSequenceIndex].secuenciaid;
                this.selectSequence(seqID);
            }
            else
            {
                this.selectedSequenceIndex = -1;
                this.secuenciaID = 0;
            }
        },

        selectSequence(seqID){
            this.secuenciaID = seqID;
            this.selectedOptionIndex = 0;

            //console.log("opcionesSecuencia = ", this.opcionesSecuencia);
            //console.log("secuenciaID = ", this.secuenciaID);
            
            var i;
            for (i = 0; i < this.secuenciasFormativas.length; i ++)
            {
                if (this.secuenciasFormativas[i].secuenciaid === this.secuenciaID)
                {
                    this.opcionesSecuencia = this.secuenciasFormativas[i].opciones;
                    this.selectedSeqName = this.secuenciasFormativas[i].secuencia;
                    this.selectedSequenceIndex = i;
                    break;
                }
            }
        },

        selectFirstOption()
        {
            if (this.opcionesSecuencia.length > 0)
            {
                this.selectedOptionIndex = 0;
                var optID = this.opcionesSecuencia[this.selectedOptionIndex].opcionid;
                this.selectOption(optID);
            }
            else
            {
                this.selectedOptionIndex = -1;
                this.opcionID = 0;
            }
        },

        selectOption(optID)
        {
            this.opcionID = optID;
            //console.log("selectOption, optionID = ", this.opcionID);

             var i;
            for (i = 0; i < this.opcionesSecuencia.length; i ++)
            {
                if (this.opcionesSecuencia[i].opcionid === this.opcionID)
                {
                    this.selectedOptName = this.opcionesSecuencia[i].opcion;
                    this.selectedOptionIndex = i;
                    break;
                }
            }
        },

        onNewPlan() {
            this.bEditPlan = true;
            this.bNewPlan = true;
            this.selectedPlanIndex = -1;

            this.planID = 0;
            this.nombrePlan = '';
            this.periodoInicioID = 0;
            this.anioInicio = 0;
            //this.creditosPlan = 0;
            this.creditosObligatorias = 0;
            this.creditosOptativas = 0;
            this.numOptativas = 0;
            
            this.secuenciasFormativas = [];
            this.opcionesSecuencia = [];
            //this.materias = [];
            this.selectedPlanName = 'Nuevo Plan';

            this.materiaID = 0;
            this.nombreMateria = '';
            this.clave = '';
            this.sigla = '';
            this.creditosMateria = 0;
            this.horas = 0;
            this.semestreIdeal = '';
            //this.categoriaID = 0;
            this.obligatoria = false;
            this.verano = false;
            this.areaID = 0;
            this.materiaSecuenciaID = 0;
            this.materiaOpcionID = 0;
            this.descripcion = '';
            this.prerrequisitos = [];
            this.selectedCourseName = '';

            this.$refs.plan_name_field.focus();

            //console.log("secuenciasFormativas = ", this.secuenciasFormativas);
            
        },
        onDeletePlan() {
            this.bDeletingPlan = true;
        },
        cancelDeletePlan() {
            this.bDeletingPlan = false;
        },
        deletePlanConfirmed() {
            this.bDeletingPlan = false;

            //Como el borrado en el servidor es asíncrono, antes de borrar el registro en el servidor se borra
            //el registro localmente. Si no, si el registro borrado era el primer registro, si primero se
            //borra en el servidor y después se selecciona el primer registro, es posible que se vuelva a
            //seleccionar el registro borrado antes de que éste se borre en el servidor.

            var i;
            for (i = 0; i < this.planesEstudios.length; i++)
            {
                if (this.planesEstudios[i].planid === this.planID)
                {
                    this.planesEstudios.splice(i, 1);
                    break;
                }
            }

            this.$store.dispatch('deletePlan', this.planID);
            this.selectFirstPlan();
        },

        onEditPlan() {
            this.bEditPlan = true;
        },
        
        onCancelEditPlan() {
            if (this.bNewPlan) {
                //Selecciona al primer plan de la lista:
                this.selectFirstPlan();
                this.bNewPlan = false;
            } else {
                //Vuelve a obtener los datos originales del plan seleccionado:
                this.selectPlan(this.planID);
            }
            this.bEditPlan = false;
        },

        onSavePlan()
        {
            this.bInvalidData = false;

            //Se validan los datos:

            if (this.nombrePlan === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'Escriba el nombre del plan de estudios.';
            }
            else
            // if (this.fechaInicio === '')
            // {
            //     this.bInvalidData = true;
            //     this.errorMessage = 'Introduzca la fecha de inicio del plan de estudios.';
            // }
            if (this.periodoInicioID === 0)
            {
                this.bInvalidData = true;
                this.errorMessage = 'Introduzca el periododo de inicio del plan de estudios.';
            }
            else
            // if (this.cuentaInicial < 1)
            // {
            //     this.bInvalidData = true;
            //     this.errorMessage = 'Introduzca un número de cuenta inicial válido.';
            // }
            if ((this.anioInicio < 2000) || (this.anioInicio > 3000))
            {
                this.bInvalidData = true;
                this.errorMessage = 'Introduzca un año de inicio válido para el plan de estudios.';
            }
            else
            if (this.creditosObligatorias < 0)
            {
                this.bInvalidData = true;
                this.errorMessage = 'Introduzca el número de créditos de las materias obligatorias.';
            }
            else
            if (this.creditosOptativas < 0)
            {
                this.bInvalidData = true;
                this.errorMessage = 'Introduzca el número de créditos de las materias optativas.';
            }
            else
            {
                //Checa si hay otro plan con el mismo nombre:
                for (let i = 0; i < this.planesEstudios.length; i ++)
                {
                    //Si se está editando el plan, se salta el plan en edición (si es un plan nuevo planID = 0):
                    if (this.planesEstudios[i].planid === this.planID)
                    {
                        continue;
                    }
                    else
                    if (this.planesEstudios[i].plan === this.nombrePlan)
                    {
                        //console.log("Plan igual encontrado...");
                        this.bInvalidData = true;
                        this.errorMessage = "Ya existe otro plan con el mismo nombre."
                        break;
                    }
                }
            }

            if (!this.bNewPlan && !this.bInvalidData)
            {
                //Edición de plan de estudios...

                const planInfo = {
                    planid: this.planID,
                    nombrePlan: this.nombrePlan,
                    anioInicio: this.anioInicio,
                    periodoInicioid: this.periodoInicioID,
                    //creditos: this.creditosPlan,
                    creditos: this.totalCreditos,
                    creditosOptativas: this.creditosOptativas,
                    creditosObligatorias: this.creditosObligatorias,
                    numOptativas: this.numOptativas,
                    secuenciasFormativas: this.secuenciasFormativas,
                };
                //console.log('planInfo = ', planInfo);

                this.$store.dispatch('editPlan', planInfo);

            } //end edición de plan.
            else if (this.bNewPlan && !this.bInvalidData)
            {
                //Registro de nuevo plan...

                this.bNewPlan = false;

                const newPlan = {
                    planid: this.planID,
                    nombrePlan: this.nombrePlan,
                    //fechaInicio: this.fechaInicio,
                    anioInicio: this.anioInicio,
                    periodoInicioid: this.periodoInicioID,
                    //creditos: this.creditosPlan,
                    creditos: this.totalCreditos,
                    creditosObligatorias: this.creditosObligatorias,
                    creditosOptativas: this.creditosOptativas,
                    numOptativas: this.numOptativas,
                    secuenciasFormativas: this.secuenciasFormativas,
                };

                this.$store.dispatch('saveNewPlan', newPlan);
                
            } //end registro de nuevo plan.

            if (!this.bInvalidData)
            {
                this.selectedPlanName = this.nombrePlan;
                this.bEditPlan = false;
            }
        },

        selectFirstPlan()
        {
            if (this.planesEstudios.length > 0)
            {
                this.selectedPlanIndex = 0;
                var planID = this.planesEstudios[this.selectedPlanIndex].planid;
                this.selectPlan(planID);
            }
            else
            {
                this.selectedPlanIndex = -1;
                this.planID = 0;
            }
        },

        selectPlan(planID)
        {
            this.materiaID = 0;
            this.nombreMateria = '';
            this.clave = '';
            this.sigla = '';
            this.creditosMateria = 0;
            this.horas = 0;
            this.semestreIdeal = '';
            this.obligatoria = false;
            this.verano = false;
            this.areaID = 0,
            this.materiaSecuenciaID = 0,
            this.materiaOpcionID = 0,
            this.descripcion = '';
            this.prerrequisitos = [],
            this.selectedCourseName = '';

            this.loadingData = true; //Para no dejar seleccionar otro plan antes de que se haya terminado de cargar toda la información.
            this.planID = planID;
            this.$store.dispatch('getPlanData', planID);
        },

        selectFirstCourse()
        {
            //console.log("SelectFirstCourse...");
            if (this.materiasPlan.length > 0)
            {
                this.selectedCourseIndex = 0;
                var materiaID = this.materiasPlan[this.selectedCourseIndex].materiaid;
                this.selectCourse(materiaID);
            }
            else
            {
                this.selectedCourseIndex = -1;
                this.materiaID = 0;
            }
        },

        selectCourse(materiaID)
        {
            this.materiaID = materiaID;
            this.$store.dispatch('getMateria', materiaID);
        },

        selectFirstNoPrerreq()
        {
            if (this.noPrerrequisitos.length > 0)
            {
                this.selectedNoPrerreqIndex = 0;
                var materiaID = this.noPrerrequisitos[this.selectedNoPrerreqIndex].materiaid;
                this.selectNoPrerreq(materiaID);
            }
            else
            {
                this.selectedNoPrerreqIndex = -1;
                this.noPrerreqID = 0;
            }
        },

        selectNoPrerreq(materiaID)
        {
            this.noPrerreqID = materiaID;
            this.$store.dispatch('getNoPrerreq', materiaID);
        },

        onNewSeq(){
            this.bNewSeq = true;
            this.seqToEdit = '';
            this.mandatoryCourses = 0;
            this.optionalCourses = 0;
            this.sequenceLabel = '';
            //Obtiene un ID negativo temporal para la nueva secuencia:
            this.secuenciaID = - this.secuenciasFormativas.length;
            this.newSeqID = this.secuenciaID;

             this.bDlgEditSeq = true;
        },

        onEditSeq(){
            this.bDlgEditSeq = true;
            this.bNewSeq = false;
            this.seqToEdit = this.secuenciasFormativas[this.selectedSequenceIndex].secuencia;
            this.mandatoryCourses = this.secuenciasFormativas[this.selectedSequenceIndex].materiasObligatorias;
            this.optionalCourses = this.secuenciasFormativas[this.selectedSequenceIndex].materiasOptativas;
            this.sequenceLabel = this.secuenciasFormativas[this.selectedSequenceIndex].leyenda;
        },

        onCancelSeqEdition()
        {
            this.bNewSeq = false;
            this.bDlgEditSeq = false;
        },

        onConfirmSeqEdition()
        {
            //Validación de datos:

            this.bInvalidData = false;
            if (this.seqToEdit === '')
            {
                this.bInvalidData = true;
                this.errorMessage = "Teclee el nombre de la secuencia formativa."
            }
            else
            if ((isNaN(this.mandatoryCourses) || this.mandatoryCourses ==="") || (this.mandatoryCourses < 0))
            {
                this.bInvalidData = true;
                this.errorMessage = "Teclee un número de materias obligatorias válido."
            }
            else
            if ((isNaN(this.optionalCourses) || this.optionalCourses ==="") || (this.optionalCourses < 0))
            {
                this.bInvalidData = true;
                this.errorMessage = "Teclee un número de materias optativas válido."
            }
            else
            {
                //Checa si hay otra secuencia con el mismo nombre:
                var i;
                for (i = 0; i < this.secuenciasFormativas.length; i ++)
                {
                    //Si se está editando la secuencia, se salta la secuencia en edición (si es una secuencia nueva, secuenciaID es negativo y diferente a cualquier otro ID):
                    if (this.secuenciasFormativas[i].secuenciaid === this.secuenciaID)
                    {
                        continue;
                    }
                    else
                    if (this.secuenciasFormativas[i].secuencia === this.seqToEdit)
                    {
                        this.bInvalidData = true;
                        this.errorMessage = "Ya existe otra secuencia con el mismo nombre."
                        break;
                    }
                }
            }

            if (!this.bNewSeq && !this.bInvalidData) //Edición de secuencia...
            {
                this.secuenciasFormativas[this.selectedSequenceIndex].secuencia = this.seqToEdit;
                this.secuenciasFormativas[this.selectedSequenceIndex].materiasObligatorias = this.mandatoryCourses;
                this.secuenciasFormativas[this.selectedSequenceIndex].materiasOptativas = this.optionalCourses;
                this.secuenciasFormativas[this.selectedSequenceIndex].leyenda = this.sequenceLabel;
                this.selectedSeqName = this.seqToEdit;
                this.bNewSeq = false;
                this.bDlgEditSeq = false;
            }
            else
            if (this.bNewSeq && !this.bInvalidData)  //Nueva secuencia...
            {
                var newSeq = {
                    secuenciaid: this.newSeqID,
                    secuencia: this.seqToEdit,
                    materiasObligatorias: this.mandatoryCourses,
                    materiasOptativas: this.optionalCourses,
                    leyenda: this.sequenceLabel,
                    opciones: []
                }
                this.secuenciasFormativas.push(newSeq);
                this.bDlgEditSeq = false;

                this.selectSequence(this.newSeqID);
                this.newSeqID = 0;
            }
            
        },


        onDeleteSeq(){
            this.bDeletingSeq = true;
        },

        cancelDeleteSeq() {
            this.bDeletingSeq = false;
        },

        deleteSeqConfirmed(){
            this.bDeletingSeq = false;

            var i;
            for (i = 0; i < this.secuenciasFormativas.length; i ++)
            {
                if (this.secuenciasFormativas[i].secuenciaid === this.secuenciaID)
                {
                    this.secuenciasFormativas.splice(i, 1);
                    break;
                }
            }

            this.opcionesSecuencia = [];
            this.selectFirstSecuence();
        },

        onNewOption(){
            this.bNewOption = true;
            this.optionToEdit = '';
            //Obtiene un ID negativo temporal para la nueva opción:
            this.opcionID = - this.opcionesSecuencia.length;
            this.newOptID = this.opcionID;

            this.bDlgEditOption = true;
        },

        onEditOption(){
            this.bDlgEditOption = true;
            this.bNewOption = false;
            this.optionToEdit = this.opcionesSecuencia[this.selectedOptionIndex].opcion;
        },

        onCancelOptionEdition()
        {
            this.bNewOption = false;
            this.bDlgEditOption = false;
        },

        onConfirmOptionEdition()
        {
            //Validación de datos:
            this.bInvalidData = false;
            if (this.optionToEdit === '')
            {
                this.bInvalidData = true;
                this.errorMessage = "Teclee el nombre de la opción."
            }
            else
            {
                //Checa si hay otra opción con el mismo nombre:
                var i;
                for (i = 0; i < this.opcionesSecuencia.length; i ++)
                {
                    //Si se está editando la opción, se salta la opción en edición (si es una nueva opción, opcionID es negativo y diferente a cualqiuer otro ID)
                    if (this.opcionesSecuencia[i].opcionid === this.opcionID)
                    {
                        continue;
                    }
                    else
                    if (this.opcionesSecuencia[i].opcion === this.optionToEdit)
                    {
                        this.bInvalidData = true;
                        this.errorMessage = "Ya existe otra opción con el mismo nombre."
                        break;
                    }
                }

                if (!this.bNewOption && !this.bInvalidData) //Edición de opción...
                {
                    this.opcionesSecuencia[this.selectedOptionIndex].opcion = this.optionToEdit;
                    this.selectedOptName = this.optionToEdit;
                    this.bNewOption = false;
                    this.bDlgEditOption = false;
                }
                else
                if (this.bNewOption && !this.bInvalidData) //Nueva opción...
                {
                    var newOpt = {
                        opcionid: this.newOptID,
                        opcion: this.optionToEdit
                    }
                    this.opcionesSecuencia.push(newOpt);
                    this.bDlgEditOption = false;

                    this.selectOption(this.newOptID);
                    this.newOptID = 0;
                }
            }
        },

        onDeleteOption(){
            this.bDeletingOption = true;
        },

        cancelDeleteOption(){
            this.bDeletingOption = false;
        },

        deleteOptionConfirmed() {
            this.bDeletingOption = false;

            var i;
            for (i = 0; i < this.opcionesSecuencia.length; i ++)
            {
                if (this.opcionesSecuencia[i].opcionid === this.opcionID)
                {
                    this.opcionesSecuencia.splice(i, 1);
                    break;
                }
            }

            this.selectFirstOption();
        },

        onNewCourse(){
            this.bEditCourse = true;
            this.bNewCourse = true;
            this.selectedCourseIndex = -1;

            this.materiaID = 0;
            this.nombreMateria = '';
            this.clave = '';
            this.sigla = '';
            this.creditosMateria = 0;
            this.horas = 0;
            this.semestreIdeal = '';
            //this.categoriaID = 0;
            this.obligatoria = false;
            this.verano = false;
            this.areaID = 0;
            this.colorArea = "";
            this.materiaSecuenciaID = 0;
            this.materiaOpcionesSecuencia = [];
            this.materiaOpcionID = 0;
            this.descripcion = '';
            this.prerrequisitos = [];
            this.selectedCourseName = '';

            this.$refs.materia_name_field.focus();
            
        },

        onEditCourse(){
            this.bEditCourse = true;
        },

        onDeleteCourse(){
            this.bDeletingCourse = true;
        },

        cancelDeleteCourse(){
            this.bDeletingCourse = false;
        },

        deleteCourseConfirmed(){
            this.bDeletingCourse = false;

            //Como el borrado en el servidor es asíncrono, antes de borrar el registro en el servidor se borra
            //el registro localmente. Si no, si el registro borrado era el primer registro, si primero se
            //borra en el servidor y después se selecciona el primer registro, es posible que se vuelva a
            //seleccionar el registro borrado antes de que éste se borre en el servidor.

            for (let i = 0; i < this.materiasPlan.length; i++)
            {
                if (this.materiasPlan[i].materiaid === this.materiaID)
                {
                    this.materiasPlan.splice(i, 1);
                    break;
                }
            }

            this.$store.dispatch('deleteCourse', this.materiaID);
            this.selectFirstPlan();
        },

        onAddPrereq(){
            //Crea el arreglo de materias disponibles para ser prerrequisitos:
            this.createNoPrerreq();

            this.selectFirstNoPrerreq();
            this.bDlgAddPrereq = true;
        },

        cancelAddPrereq(){
            this.bDlgAddPrereq = false;
        },

        confirmAddPrereq() {
            var newPrerreq = {
                materiaid: this.noPrerreqID,
                materia: this.nombrePrerreq,
                clave: this.clavePrerreq
            }
            this.prerrequisitos.push(newPrerreq);

            //console.log("newPrerreq = ", newPrerreq);

            //Selecciona al prerrequisito agregado:
            for (let i = 0; i < this.prerrequisitos.length; i ++)
            {
                if (this.prerrequisitos[i].materiaid === this.noPrerreqID)
                {
                    this.selectedPrerreqIndex = i;
                    this.selectPrereq(this.prerrequisitos[i].materiaid)
                    break;
                }
            }
            this.bDlgAddPrereq = false;
        },

        selectFirstPrereq(){
            if (this.prerrequisitos.length > 0)
            {
                this.selectedPrerreqIndex = 0;
                var prerreqID = this.prerrequisitos[this.selectedPrerreqIndex].materiaid;
                this.selectPrereq(prerreqID);
            }
            else
            {
                this.prerreqID = 0;
                this.selectedPrereqName = "";
            }
        },

        selectPrereq(materiaID){
            this.prerreqID = materiaID;
            for (let i = 0; i < this.prerrequisitos.length; i ++)
            {
                if (this.prerrequisitos[i].materiaid === materiaID)
                {
                    this.selectedPrereqName = this.prerrequisitos[i].materia;
                    //console.log("selectedPrereqName = ", this.selectedPrereqName);
                    break;
                }
            }
        },

        onDeletePrereq(){
            if (this.prerreqID !== 0)
            {
                this.bDeletingPrereq = true;
            }
        },

        cancelDeletePrereq(){
            this.bDeletingPrereq = false;
        },

        confirmDeletePrereq(){
            for (let i = 0; i < this.prerrequisitos.length; i ++)
            {
                if (this.prerrequisitos[i].materiaid === this.prerreqID)
                {
                    this.prerrequisitos.splice(i, 1);
                    break;
                }
            }

            this.bDeletingPrereq = false;
            this.selectFirstPrereq();
        },

        getOpcionesSecuencia(){
            this.materiaOpcionesSecuencia = [];
            for (let i = 0; i < this.secuenciasFormativas.length; i ++)
            {
                if (this.secuenciasFormativas[i].secuenciaid === this.materiaSecuenciaID)
                {
                    this.materiaOpcionesSecuencia = this.secuenciasFormativas[i].opciones;
                    //console.log("this.materiaOpcionID = ", this.materiaOpcionID);
                    break;
                }
            }
        },

        onSelectSecuenciaMateria(){
            this.materiaOpcionID = 0;
            //console.log("onSelectSecMateria, materiaSecuenciaID = ", this.materiaSecuenciaID);

            if (this.materiaSecuenciaID === undefined)
            {
                this.materiaSecuenciaID = 0;
                this.materiaOpcionID = 0;
            }
            this.getOpcionesSecuencia();
        },

        onSelectAreaMateria(){
            for (let i = 0; i < this.areas.length; i ++)
            {
                if (this.areas[i].areaid === this.areaID)
                {
                    this.colorArea = this.areas[i].color;
                    break;
                }
            }
        },

        onSaveCourse(){
            this.bInvalidData = false;

            //Se validan los datos:

            if (this.nombreMateria === '')
            {
                this.bInvalidData = true;
                this.errorMessage = "Teclee el nombre de la materia.";
            }
            else
            if (this.clave === '')
            {
                this.bInvalidData = true;
                this.errorMessage = "Teclee la clave de la materia.";
            }
            else
            if (this.sigla === '')
            {
                this.bInvalidData = true;
                this.errorMessage = "Teclee la sigla de la materia.";
            }
            else
            if (this.creditosMateria < 1)
            {
                this.bInvalidData = true;
                this.errorMessage = "Introduzca un número de créditos válido.";
            }
            else
            if (this.horas < 1)
            {
                this.bInvalidData = true;
                this.errorMessage = "Introduzca un número de horas por semana válido.";
            }
            else
            if (this.semestreIdeal < 1)
            {
                this.bInvalidData = true;
                this.errorMessage = "Introduzca un semestre ideal válido.";
            }
            else
            if (this.areaID === 0)
            {
                this.bInvalidData = true;
                this.errorMessage = "Seleccione el área de la materia.";
            }
            else
            if ((this.materiaSecuenciaID !== 0) && (this.materiaOpcionID === 0))
            {
                this.bInvalidData = true;
                this.errorMessage = "Seleccione una opción para la secuencia formativa.";
            }
            else
            if (this.descripcion.length > 255)
            {
                this.bInvalidData = true;
                this.errorMessage = "La descripción de la materia no puede tener más de 255 caracteres.";
            }
            else
            {
               //Checa si hay otra materia con los mismos datos:
               for (let i = 0; i < this.materiasPlan.length; i ++)
               {
                   //Si se está editando la materia, se salta la materia en edición (si es un materia nueva materiaID = 0):
                   if (this.materiasPlan[i].materiaid === this.materiaID)
                   {
                       continue;
                   }
                   else
                   if (this.materiasPlan[i].materia === this.nombreMateria)
                   {
                       this.bInvalidData = true;
                       this.errorMessage = "Ya existe otra materia con el mismo nombre.";
                       break;
                   }
                   else
                   if (this.materiasPlan[i].clave === this.clave)
                   {
                        this.bInvalidData = true;
                        this.errorMessage = "Ya existe otra materia con la misma clave.";
                        break;
                   }
                   else
                   if (this.materiasPlan[i].sigla === this.sigla)
                   {
                        this.bInvalidData = true;
                        this.errorMessage = "Ya existe otra materia con la misma sigla.";
                        break;
                   }
               }
            }
            if ( !this.bInvalidData)
            {
                const courseInfo = {
                    planid: this.planID,
                    materiaid: this.materiaID,
                    materia: this.nombreMateria,
                    clave: this.clave,
                    sigla: this.sigla,
                    creditos: this.creditosMateria,
                    horas: this.horas,
                    semestreIdeal: this.semestreIdeal,
                    prerrequisitos: this.prerrequisitos,
                    obligatoria: this.obligatoria,
                    verano: this.verano,
                    descripcion: this.descripcion,
                    areaid: this.areaID,
                    secuenciaFormativaid: this.materiaSecuenciaID,
                    opcionid: this.materiaOpcionID,
                }
                //console.log("onSaveCourse, courseInfo = ", courseInfo);

                this.bCourseEdited = true; //Para que cuando la lista de materias se refresque no se seleccione automáticamente la primera.

                if (!this.bNewCourse) //Edición de materia...
                {
                    this.$store.dispatch('editCourse', courseInfo);
                }
                else
                if (this.bNewCourse) //Registro de nueva materia...
                {
                    this.bNewCourse = false;
                    this.$store.dispatch('saveNewCourse', courseInfo);
                }

                this.selectedCourseName = this.nombreMateria;
                this.bEditCourse = false;
            }
        },

        onCancelEditCourse(){
            if (this.bNewCourse)
            {
                //Selecciona la primera materia de la lista:
                this.selectFirstCourse();
                this.bNewCourse = false;
            }
            else
            {
                //Vuelve a obtener los datos originales de la materia seleccionada:
                this.selectCourse(this.materiaID);
            }
            this.bEditCourse = false;
            

        },

        createNoPrerreq()
        {
            //Crea el arreglo de materias que pueden ser prerrequisitos de la materia seleccionada (pero aún no lo son):
            this.noPrerrequisitos = [];

            //console.log("materias = ", this.materiasPlan);
            //console.log("materiaID = ", this.materiaID);

            for (let i = 0; i < this.materiasPlan.length; i ++)
            {
                //Si la materia es la materia seleccionada, se salta:
                if (this.materiasPlan[i].materiaid === this.materiaID)
                {
                    continue;
                }
                else
                //Se checa si la materia ya es prerrequisito:
                var alreadyPrereq = false;
                for (let j = 0; j < this.prerrequisitos.length; j ++)
                {
                    if (this.prerrequisitos[j].materiaid === this.materiasPlan[i].materiaid){
                        alreadyPrereq = true;
                        break;
                    }
                    //Si llegamos a este punto, la materia ni es la seleccionada ni es prerrequisito, por lo que se agrega a la lista:
                }
                if (!alreadyPrereq)
                {
                    this.noPrerrequisitos.push(this.materiasPlan[i]);
                }
            }
        },

        onSearchCourse()
        {
            if (this.searchText != '')
            {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var bFound = false;
                for (let i = 0; i < this.materiasPlan.length; i++)
                {
                    let strLowerCaseMateria = this.materiasPlan[i].materia.toLowerCase();
                    let strLowerCaseClave = this.materiasPlan[i].clave.toLowerCase();
                    let strLowerCaseSigla = this.materiasPlan[i].sigla.toLowerCase();
                    if ((strLowerCaseMateria.indexOf(searchTextLowerCase) === 0) ||
                        (strLowerCaseClave.indexOf(searchTextLowerCase) === 0) ||
                        (strLowerCaseSigla.indexOf(searchTextLowerCase) === 0))
                    {
                        this.selectedCourseIndex = i;
                        this.scroll(this.materiaID);
                        this.selectCourse(this.materiasPlan[i].materiaid);
                        bFound = true;
                        break;
                    }
                }
                if (!bFound)
                {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        },

        onSearchNoPrerreq()
        {
            if (this.searchText != '')
            {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var bFound = false;
                for (let i = 0; i < this.noPrerrequisitos.length; i++)
                {
                    let strLowerCaseMateria = this.noPrerrequisitos[i].materia.toLowerCase();
                    let strLowerCaseClave = this.noPrerrequisitos[i].clave.toLowerCase();
                    let strLowerCaseSigla = this.noPrerrequisitos[i].sigla.toLowerCase();
                    if ((strLowerCaseMateria.indexOf(searchTextLowerCase) === 0) ||
                        (strLowerCaseClave.indexOf(searchTextLowerCase) === 0) ||
                        (strLowerCaseSigla.indexOf(searchTextLowerCase) === 0))
                    {
                        this.selectedNoPrerreqIndex = i;
                        
                        this.selectNoPrerreq(this.noPrerrequisitos[i].materiaid);
                        this.scroll(-this.noPrerreqID);
                        bFound = true;
                        break;
                    }
                }
                if (!bFound)
                {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        },

        scroll(id)
        {
            //console.log("En scroll, id = ", id);
            if (document.getElementById(id) !== null)
            {
                document.getElementById(id).scrollIntoView({behavior: "smooth"});
            }
        }
    },
    computed:
    {
        ...mapGetters([
            'waitCursor',
            'areas'
        ]),

        totalCreditos(){
            return + this.creditosObligatorias + + this.creditosOptativas; //"+" para que no se concatenen como strngs.
        },

        opcionesListTitle(){
            var strTitle = "Opciones";

            if (this.secuenciasFormativas.length > 0)
            {
                strTitle += " para " + this.selectedSeqName;
            }
            
            return strTitle;
        },

        selectedPlanIndex:
        {
            get() {
                return this.$store.getters.selectedPlanIndex;
            },
            set(selectedPlanIndex) {
                this.$store.dispatch( 'updateSelectedPlanIndex', selectedPlanIndex);
            },
        },

        selectedCourseIndex:
        {
           get() {
                return this.$store.getters.selectedCourseIndex;
            },
            set(selectedCourseIndex) {
                this.$store.dispatch( 'updateSelectedCourseIndex', selectedCourseIndex);
            },
        },

        planesEstudios: {
            get() {
                return this.$store.getters.planesEstudios;
            },
            set(planesEstudios) {
                this.$store.dispatch('updatePlanesEstudios', planesEstudios);
            },
        },

        planEstudios: {
            get() {
                return this.$store.getters.planEstudios;
            },
            set(planEstudios) {
                this.$store.dispatch('updatePlanEstudios', planEstudios);
            },
        },

        materiasPlan: {
            get() {
                return this.$store.getters.materiasPlan;
            },
            set(materiasPlan) {
                this.$store.dispatch('updateMateriasPlan', materiasPlan);
            },
        },

        materia: {
            get() {
                return this.$store.getters.materia;
            },
            set(materia) {
                this.$store.dispatch('updateMateria', materia);
            },
        },

        materiaID: {
            get() {
                return this.$store.getters.materiaID;
            },
            set(materiaID) {
                this.$store.dispatch('updateMateriaID', materiaID);
            },
        },

        noPrerreq: {
            get() {
                return this.$store.getters.noPrerreq;
            },
            set(noPrerreq) {
                this.$store.dispatch('updateNoPrerreq', noPrerreq);
            },
        },

        materiasPlanLoaded: {
            get() {
                return this.$store.getters.materiasPlanLoaded;
            },
            set(materiasPlanLoaded) {
                this.$store.dispatch('updateMateriasPlanLoaded', materiasPlanLoaded);
            },
        },

        materiaLoaded: {
            get() {
                return this.$store.getters.materiaLoaded;
            },
            set(materiaLoaded) {
                this.$store.dispatch('updateMateriaLoaded', materiaLoaded);
            },
        },

        noPrerreqLoaded: {
            get() {
                return this.$store.getters.noPrerreqLoaded;
            },
            set(noPrerreqLoaded) {
                this.$store.dispatch('updateNoPrerreqLoaded', noPrerreqLoaded);
            },
        },

        loadingData: {
            get() {
                return this.$store.getters.loadingData;
            },
            set(loadingData) {
                this.$store.dispatch('updateLoadingData', loadingData);
            },
        },

        planListHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '100px';
            }
            else
            if (this.$vuetify.breakpoint.sm) {
                height = '100px';
            }
            else
            if (this.bMounted)
            {
                height = this.$refs.plan_card.$el.clientHeight - this.planToolbarHeight + 'px';
                //height = this.$refs.plan_card.$el.clientHeight + 'px';
            }
            else
            {
                height = '100px';
            }
           
            return height;
        },

        seqListHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '100px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '100px';
            } else {
                height = '100px';
            }
            return height;
        },

        courseListHeight() {
            var height;
            if (this.bMounted)
            {
                height = this.$refs.course_card.$el.clientHeight - this.courseToolbarHeight + 'px';
                //height = this.$refs.course_card.$el.clientHeight - 30 + 'px';
            }
            else
            {
                height = '100px';
            }
            // if (this.$vuetify.breakpoint.xs) {
            //     height = '100px';
            // } else if (this.$vuetify.breakpoint.sm) {
            //     height = '200px';
            // } else {
            //     //height = '400px';
            //     //height = this.$refs.course_card.clientHeight;
            //     //height = document.getElementById('course_card').clientHeight;
                
                
            // }
            return height;
        },

        noPrerreqlistHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '100px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '300px';
            } else {
                height = '500px';
            }
            return height;
        },

        prerreqListHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '60px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '100px';
            } else {
                height = '130px';
            }
            return height;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },

        logoHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '40';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '40';
            } else if (this.$vuetify.breakpoint.md) {
                height = '50';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '60';
            } else {
                height = '80';
            }
            return height;
        },
    },

    watch: {

        materiasPlanLoaded: function(value, oldValue)
        {
            //console.log("materiasPlanLoaded, planEstudios = ", this.planEstudios);
            if (this.materiasPlanLoaded)
            {
                this.nombrePlan = this.planEstudios.nombrePlan;
                this.fechaInicio = this.planEstudios.fechaInicio;
                this.anioInicio = this.planEstudios.anioInicio;
                this.periodoInicioID = this.planEstudios.periodoInicioid;
                //this.creditosPlan = this.planEstudios.creditos;
                this.creditosObligatorias = this.planEstudios.creditosObligatorias;
                this.creditosOptativas = this.planEstudios.creditosOptativas;
                this.numOptativas = this.planEstudios.numOptativas;
                this.secuenciasFormativas = this.planEstudios.secuenciasFormativas;

                //this.materias = this.materiasPlan;

                //Si no se acaba de editar o registrar una materia, se selecciona la primera materia de la lista:
                if (!this.bCourseEdited)
                {
                    this.selectedPlanName = this.nombrePlan;
                    this.selectFirstSecuence();
                    this.selectFirstCourse();
                    this.bCourseEdited = false;
                }

                this.materiasPlanLoaded = false;
            }
        },

        materiaLoaded: function(value, oldValue)
        {
            if (this.materiaLoaded)
            {
                this.nombreMateria = this.materia.materia;
                this.clave = this.materia.clave;
                this.sigla = this.materia.sigla;
                this.creditosMateria = this.materia.creditos;
                this.horas = this.materia.horas;
                this.semestreIdeal = this.materia.semestreIdeal;
                this.obligatoria = this.materia.obligatoria;
                this.verano = this.materia.verano;
                this.areaID = this.materia.areaid;
                for (let i = 0; i < this.areas.length; i ++)
                {
                    if (this.areas[i].areaid === this.areaID)
                    {
                        this.colorArea = this.areas[i].color;
                        break;
                    }
                }
                this.materiaSecuenciaID = this.materia.secuenciaFormativaid;
                this.materiaOpcionID = this.materia.opcionid;
                this.descripcion = this.materia.descripcion;
                this.prerreqID = 0;
                this.selectedPrereqName = "",
                this.prerrequisitos = this.materia.prerrequisitos;

                this.selectedCourseName = this.nombreMateria;
                this.selectFirstPrereq();
                this.getOpcionesSecuencia();

                this.materiaLoaded = false;
            }
        },

        noPrerreqLoaded: function(value, oldValue)
        {
            if (this.noPrerreqLoaded)
            {
                this.nombrePrerreq = this.noPrerreq.materia;
                this.clavePrerreq = this.noPrerreq.clave;
                this.siglaPrerreq = this.noPrerreq.sigla;
                this.creditosPrerreq = this.noPrerreq.creditos;
                this.horasPrerreq = this.noPrerreq.horas;
                this.semestreIdealPrerreq = this.noPrerreq.semestreIdeal;
                this.obligatoriaPrerreq = this.noPrerreq.obligatoria;
                this.veranoPrerreq = this.noPrerreq.verano;

                this.areaPrerreq = '';
                for (let i = 0; i < this.areas.length; i ++)
                {
                    if (this.areas[i].areaid === this.noPrerreq.areaid)
                    {
                        this.areaPrerreq = this.areas[i].area;
                        break;
                    }
                }

                for (let i = 0; i < this.secuenciasFormativas.length; i ++)
                {
                    if (this.secuenciasFormativas[i].secuenciaid === this.noPrerreq.secuenciaFormativaid)
                    {
                        this.secuenciaPrerreq = this.secuenciasFormativas[i].secuencia;
                        for (let j = 0; j < this.secuenciasFormativas[i].opciones.length; j ++)
                        {
                            if (this.secuenciasFormativas[i].opciones[j].opcionid === this.noPrerreq.opcionid)
                            {
                                this.opcionPrerreq = this.secuenciasFormativas[i].opciones[j].opcion;
                                break;
                            }
                        }
                        break;
                    }
                }
                
                this.selectedNoPrereqName = this.nombrePrerreq;
                this.noPrerreqLoaded = false;
            }
        }
    }
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.6);
}
.planes {
    background: url('../assets/patiogallo2.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>